<template>
  <div class="mt-1">
    <b-card>
      <b-overlay :show="loading" rounded="sm" no-fade>
        <b-row class="mb-1">
          <!-- Per Page -->
          <b-col
            cols="12"
            md="7"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <b-button
              variant="outline-primary"
              class="btn-icon"
              :to="{ path: '/settings' }"
            >
              <i class="fa-solid fa-arrow-left"></i>
              <span class="ml-25">Back</span>
            </b-button>

            <h3 class="ml-1">Venues</h3>
          </b-col>

          <b-col cols="12" md="5">
            <div class="d-flex align-items-center justify-content-end">
              <div class="d-flex align-items-center mr-1">
                <label>Show</label>
                <v-select
                  v-model="perPage"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
                />
                <label>entries </label>
              </div>

              <b-form-input
                v-model="filter"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <b-button variant="primary" @click="addVenue()">
                <span class="text-nowrap">Add Venue</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

        <b-table
          sticky-header
          striped
          hover
          bordered
          ref="refVenueListTable"
          :outlined="true"
          :fields="fields"
          :items="filteredVenues"
          responsive="sm"
          :small="true"
          class="table table-sm table-responsive"
          :filter="filter"
          @filtered="onFiltered"
          :filter-included-fields="filterOn"
          show-empty
          empty-text="No matching records found"
          :current-page="currentPage"
          :per-page="perPage"
          @row-clicked="editVenue($event.id)"
        >
          <template #cell(name)="data">
            <div style="font-size: 1rem; max-width: 400px;" class="p-25">
              <p class="mb-0 font-weight-600">{{ data.value }}</p>
            </div>
          </template>

          <template #cell(actions)="{ item }">
            <div class="d-flex align-items-center justify-content-center">
              <b-button
                variant="warning"
                class="mr-1 p-50"
                @click.stop="editVenue(item.id)"
              >
                <i class="fa-solid fa-pen-to-square mr-25"></i>
                <span> Edit</span>
              </b-button>
              <b-button
                variant="danger"
                class="p-50"
                @click.stop="deleteVenue(item.id)"
              >
                <span>Delete</span>
              </b-button>
            </div>
          </template>
        </b-table>

        <div class="mx-2 mb-1 mt-1">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >Showing {{ dataMeta.from }} to {{ dataMeta.to }} of
                {{ dataMeta.of }} entries</span
              >
            </b-col>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-overlay>
    </b-card>

    <!-- Add/Edit Modal -->
    <b-modal
      v-model="showModal"
      :title="isEdit ? 'Edit Venue' : 'Add Venue'"
      @ok="handleSubmit"
      @cancel="resetForm"
      ok-title="Save"
      cancel-title="Cancel"
    >
      <b-form-group label="Name *" label-for="venue-name">
        <b-form-input
          id="venue-name"
          v-model="form.name"
          placeholder="Enter venue name"
          required
        />
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BOverlay,
  BPagination,
  BModal,
  BFormGroup,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { onUnmounted } from "@vue/composition-api";
import settingsStoreModule from "../settingsStoreModule";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BOverlay,
    BPagination,
    BModal,
    BFormGroup,
    vSelect,
    ToastificationContent,
  },
  data() {
    return {
      loading: false,
      showModal: false,
      isEdit: false,
      venues: [],
      form: {
        id: null,
        name: "",
      },
      fields: [
        {
          key: "name",
          label: "Venue Name",
          sortable: true,
          thStyle: "color:white!important",
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          class: "text-center",
          thStyle: "color:white!important",
        },
      ],
      totalRows: 0,
      currentPage: 1,
      perPage: Number(localStorage.getItem("venuesShow") || 50),
      pageOptions: [10, 25, 50, 100],
      sortBy: "",
      sortDesc: false,
      filter: null,
      filterOn: ["name"],
      perPageOptions: [10, 25, 50, 100],
    };
  },
  setup() {
    const MODULE = "settings";
    if (!store.hasModule(MODULE))
      store.registerModule(MODULE, settingsStoreModule);
    onUnmounted(() => {
      if (store.hasModule(MODULE)) store.unregisterModule(MODULE);
    });
  },
  computed: {
    dataMeta() {
      return {
        from:
          this.totalRows !== 0 ? this.perPage * (this.currentPage - 1) + 1 : 0,
        to:
          this.perPage * (this.currentPage - 1) + Number(this.perPage) <
          this.totalRows
            ? this.perPage * (this.currentPage - 1) + Number(this.perPage)
            : this.totalRows,
        of: this.totalRows,
      };
    },
    filteredVenues() {
      if (!this.filter) return this.venues;
      const term = this.filter.toLowerCase();
      return this.venues.filter(
        (item) => item.name && item.name.toLowerCase().includes(term)
      );
    },
  },
  watch: {
    perPage(val) {
      localStorage.setItem("venuesShow", val);
    },
  },
  created() {
    this.loadVenues();
  },
  methods: {
    async loadVenues() {
      try {
        this.loading = true;
        const response = await store.dispatch("settings/fetchVenues");
        this.venues = response.data.data || response.data;
        this.totalRows = this.venues.length;
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error loading venues",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      } finally {
        this.loading = false;
      }
    },
    addVenue() {
      this.isEdit = false;
      this.resetForm();
      this.showModal = true;
    },
    editVenue(id) {
      this.isEdit = true;
      const venue = this.venues.find((v) => v.id === id);
      if (venue) {
        this.form = { ...venue };
      }
      this.showModal = true;
    },
    async handleSubmit(bvModalEvent) {
      bvModalEvent.preventDefault();

      if (!this.form.name.trim()) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Please enter venue name",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }

      try {
        this.loading = true;
        if (this.isEdit) {
          await store.dispatch("settings/updateVenue", this.form);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Venue updated successfully",
              icon: "CheckIcon",
              variant: "success",
            },
          });
        } else {
          await store.dispatch("settings/createVenue", this.form);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Venue created successfully",
              icon: "CheckIcon",
              variant: "success",
            },
          });
        }

        this.showModal = false;
        this.resetForm();
        this.loadVenues();
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error saving venue",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async deleteVenue(id) {
      this.$bvModal
        .msgBoxConfirm("Are you sure you want to delete this venue?", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            try {
              this.loading = true;
              await store.dispatch("settings/deleteVenue", id);
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Venue deleted successfully",
                  icon: "CheckIcon",
                  variant: "success",
                },
              });
              this.loadVenues();
            } catch (error) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Error deleting venue",
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });
            } finally {
              this.loading = false;
            }
          }
        });
    },
    resetForm() {
      this.form = {
        id: null,
        name: "",
      };
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
